import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { updateMaintenanceRowData, updateTableData } from '../../store/utilities/SliceDataHelper';
import type { AppState } from '../AppStore';
import { NotificationApi } from '../../api/NotificationApi';

import type { IDeleteRequest, IPaginationRequest } from '../../../types/IApiTypes';
import type { IAce, IAceData } from '../../../types';
import { EActionType, EDataTableType } from '../../data/Constants';

export const notificationInitialState: IAce = {
  data: {},
  totalCount: 0,
  currentPage: 1,
  recordsPerPage: 15,
  searchKey: '',
};

// getNotifications is now in AceSlice
export const getNotifications = createAsyncThunk(
  'notification/getNotifications',
  async (action: IPaginationRequest, thunkAPI) => {
    return NotificationApi.getNotifications(action, thunkAPI.dispatch);
  }
);

//To delete notification(s)
export const deleteNotification = createAsyncThunk(
  'notification/deleteNotification',
  async (action: IDeleteRequest, thunkAPI) => {
    return NotificationApi.deleteNotification(action, thunkAPI.dispatch);
  }
);

//To retrigger notification
export const retriggerNotification = createAsyncThunk(
  'notification/retriggerNotification',
  async (action: string, thunkAPI) => {
    return NotificationApi.retriggerNotification(action, thunkAPI.dispatch);
  }
);

// Notification slice now only manages queue
const notificationSlice = createSlice({
  name: 'notification',
  initialState: notificationInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getNotifications.fulfilled, (state, action) => {
      if (!('error' in action.payload)) {
        if (action.payload.caller === EActionType.Refresh) {
          updateMaintenanceRowData<IAceData>(
            state.data,
            action.payload.data,
            state.currentPage,
            action.payload.searchKey,
            EDataTableType.Ace
          );
        } else {
          updateTableData(state, action.payload);
        }
      }
    });
  },
});

export const notifications = (state: AppState) => state.notifications;
export default notificationSlice.reducer;
